import axios from 'axios'
import {formatDateZone} from '@utils/date-helpers'
import {dateTimeFormat} from '@store/booking'
import {getApiUrl} from '@utils/api-helpers'

const onAdd = async (enhancement, cartLine, hotelData) => {
  const selectedTime = enhancement?.data?.selectedTime
  const lineKey = enhancement.name === 'Early Check-in' ? 'startDate' : 'endDate'
  const lineDayTime = cartLine[lineKey]
  const lineDay = lineDayTime.split('T')[0]
  const newDateTime = formatDateZone(`${lineDay} ${selectedTime}`, dateTimeFormat)
  const params = {
    ...cartLine,
    hotelCode: hotelData.id,
    cartLineId: cartLine.id,
    [lineKey]: newDateTime
  }
  console.log('params: ', params);
  try {
    const {data: cart} = await axios.put(getApiUrl('api/v1/cart/update-cart-line'), params)
    return cart
  } catch (err) {
    console.log(err)
    throw new Error(err)
  }
}

const onRemove = async (enhancement, cartLine, hotelData) => {
  const lineKey = enhancement.name === 'Early Check-in' ? 'startDate' : 'endDate'
  const hotelCheckIn = hotelData.chechIn || '12:00'
  const hotelCheckOut = hotelData.chechOut || '14:00'
  const defaultTime = enhancement.name === 'Early Check-in' ? hotelCheckIn : hotelCheckOut
  const lineDayTime = cartLine[lineKey]
  const lineDay = lineDayTime.split('T')[0]
  const newDateTime = formatDateZone(`${lineDay} ${defaultTime}`, dateTimeFormat)
  const params = {
    ...cartLine,
    hotelCode: hotelData.id,
    cartLineId: cartLine.id,
    [lineKey]: newDateTime
  }
  try {
    const {data: cart} = await axios.put(getApiUrl('api/v1/cart/update-cart-line'), params)
    return cart
  } catch (err) {
    console.log(err)
    throw new Error(err)
  }
}

const summary = (enhancement) => enhancement?.data?.selectedTime

const summaryShort = (enhancement) => enhancement?.data?.selectedTime

const description = (enhancement) => `${
  enhancement?.name
} - ${
  enhancement?.data?.selectedTime
}`

export default {summary, summaryShort, description}
